import Vue from "vue";
import i18n from "./i18n";
import Router from "vue-router";
import store from "./store/store.js";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Users from "./views/Settings/Users.vue";
import PasswordRecovery from "./views/Users/PasswordRecovery.vue";
import PasswordReset from "./views/Users/PasswordReset.vue";
import UserForm from "./views/Settings/UserForm.vue";
import Roles from "./views/Settings/UserRoles.vue";
import RoleForm from "./views/Settings/UserRoleForm.vue";
import AMSearch from "./views/Settings/AMSearch.vue";
import AMAliases from "./views/Settings/AMAliases.vue";
import AMCrosses from "./views/Settings/AMCrosses.vue";
import SupplierPricelists from "./views/Settings/SupplierPricelists.vue";
import SupplierPricelistForm from "./views/Settings/SupplierPricelistsForm.vue";
import Suppliers from "./views/Settings/Suppliers.vue";
import Customers from "./views/Customers/Customers.vue";
import Garage from "./views/Garage/Garage.vue";
import Goods from "./views/Storage/Goods.vue";
import GoodsIncoming from "./views/Storage/GoodsIncoming.vue";
import GoodsRelocation from "./views/Storage/GoodsRelocation.vue";
import GoodsWriteoff from "./views/Storage/GoodsWriteoff.vue";
import GoodsRemains from "./views/Storage/GoodsRemains.vue";
import Storage from "./views/Storage/Storage.vue";
import Storages from "./views/Storage/Storages.vue";
import ImportToStorage from "./views/Storage/ImportToStorage.vue";
import Orders from "./views/Orders/Orders.vue";
import Calculations from "./views/Calculations/Calculations.vue";
import Search from "./views/Search/Search.vue";
import Calendar from "./views/Calendar/Calendar.vue";

import Analytics from "./views/Analytics/Analytics.vue";
import AnalyticsSummary from "./views/Analytics/Summary.vue";
import AnalyticsWorkers from "./views/Analytics/Workers.vue";
import AnalyticsOrders from "./views/Analytics/Orders.vue";
import AnalyticsFinances from "./views/Analytics/Finances.vue";
import AnalyticsTargets from "./views/Analytics/Targets.vue";
import AnalyticsPosts from "./views/Analytics/Posts.vue";

import Settings from "./views/Settings/Settings.vue";
import SettingsGeneral from "./views/Settings/General.vue";
import BankRequisites from "./views/Settings/BankRequisites.vue";
import SettingsStatuses from "./views/Settings/Statuses.vue";
import SettingsPersonal from "./views/Settings/Personal.vue";
import SettingsStatusForm from "./views/Settings/StatusForm.vue";

import SettingsWidget from "./views/Settings/Widget.vue";
import SettingsImportExternalData from "./views/Settings/ImportExternalData";
import SettingsAPIAccess from "./views/Settings/APIAccess";

import SettingsRepairTimeTypes from "./views/Settings/RepairTimeTypes.vue";
import SettingsRepairTimeTypeForm from "./views/Settings/RepairTimeTypeForm.vue";
import SettingsRepairTimeTree from "./views/Settings/RepairTimeTree.vue";

import SettingsCustomerTypes from "./views/Settings/CustomerTypes.vue";
import SettingsCustomerTypeForm from "./views/Settings/CustomerTypeForm.vue";
import SettingsSourcesTypes from "./views/Settings/CustomerSources.vue";
import SettingsSourcesTypeForm from "./views/Settings/CustomerSourceForm.vue";

import SettingsOrderStages from "./views/Settings/OrderStages.vue";
import SettingsOrderStageForm from "./views/Settings/OrderStageForm.vue";

import SettingsSmsTemplates from "./views/Settings/SmsTemplates.vue";
import SettingsSmsTemplateForm from "./views/Settings/SmsTemplateForm.vue";

import SettingsGoodsExport from "./views/Settings/GoodsExport.vue";
import SettingsGoodsExportForm from "./views/Settings/GoodsExportForm.vue";
import SettingsGoodsExportOzonSellerAPI from "./views/Settings/GoodsExportOzonSellerAPI.vue";

import SettingsPricesTypes from "./views/Settings/PricesTypes.vue";
import SettingsPricesTypeForm from "./views/Settings/PricesTypeForm.vue";

import SettingsPosts from "./views/Settings/Posts.vue";
import SettingsPostForm from "./views/Settings/PostForm.vue";

import Diagnostics from "./views/Settings/Diagnostics.vue";

import SettingsPricemarkups from "./views/Settings/Pricemarkups.vue";
import SettingsPricemarkupForm from "./views/Settings/PricemarkupForm.vue";

import SettingsTelephonies from "./views/Settings/Telephonies.vue";
import SettingsSmsGateways from "./views/Settings/SmsGateways.vue";

import SettingsKKM from "./views/Settings/KKM.vue";
import SettingsNavigationMenu from "./views/Settings/NavigationMenu.vue";

import SettingsTarrifplans from "./views/Settings/Tarrifplans.vue";
import ShopPaymentDetails from "./views/Settings/ShopPaymentDetails.vue";
import ShopWorkingHours from "./views/Settings/ShopWorkingHours.vue";
import Shops from "./views/Settings/Shops.vue";
import Calls from "./views/Calls/Calls.vue";
import Bids from "./views/Bids/Bids.vue";
import BidsList from "./views/Bids/BidsList.vue";
import BidsDesc from "./views/Bids/BidsDesc.vue";
import FatalError from "@/views/FatalError";
import navigationDrawerComponent from "@/components/common/NavigationDrawerComponent";

Vue.use(Router);
const isEnabledStorageV2 = process.env.VUE_APP_IS_ENABLED_STORAGE_V2 === true || (process.env.VUE_APP_IS_ENABLED_STORAGE_V2 && process.env.VUE_APP_IS_ENABLED_STORAGE_V2.toLowerCase() === 'true')
let router = new Router({
  //mode: 'history',
  base: "/",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/login/:goto?",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        store.dispatch("auth/check").then(()=>{
          return store.getters["auth/authenticated"] === true ? next("/") : next();
        })
      },
    },
    {
      path: "/password-recovery",
      name: "password-recovery",
      component: PasswordRecovery,
      beforeEnter: (to, from, next) => {
        store.getters["auth/authenticated"] === true ? next("/") : next();
      },
    },
    {
      path: "/password-reset/:token?/:email?",
      name: "password-reset",
      component: PasswordReset,
      beforeEnter: (to, from, next) => {
        store.getters["auth/authenticated"] === true ? next("/") : next();
      },
    },

    {
      path: "/customers",
      name: "customers",
      component: Customers,
    },
    {
      path: "/calls",
      name: "calls",
      component: Calls,
    },
    {
      path: "/bids",
      name: 'bids',
      component: Bids,
      children: [
        { path: "", component: BidsList, name: "bids-list" },
        { path: "desc", component: BidsDesc, name: "bids-desk" },
      ],
    },
    {
      path: "/garage",
      name: "garage",
      component: Garage,
    },
    {
      path: "/storage",
      component: Storage,
      children: [
        { path: "", component: isEnabledStorageV2 ? GoodsRemains : Goods, name: "storage" },
        { path: "goods", component: Storages, name: "goods" },
        {
          path: "goods-incoming",
          component: GoodsIncoming,
          name: "goods-incoming",
        },
        {
          path: "goods-relocation",
          component: GoodsRelocation,
          name: "goods-relocation",
        },
        {
          path: "goods-writeoff",
          component: GoodsWriteoff,
          name: "goods-writeoff",
        },
        {
          path: "goods-remains",
          component: GoodsRemains,
          name: "goods-remains",
        },
        { path: "storages", component: Storages, name: "storages" },
        { path: "import", component: ImportToStorage, name: "storages-import" },
      ],
    },
    {
      path: "/analytics",
      component: Analytics,
      children: [
        { path: "", component: AnalyticsSummary, name: "analytics" },
        {
          path: "workers",
          component: AnalyticsWorkers,
          name: "analytics-workers",
        },
        {
          path: "orders",
          component: AnalyticsOrders,
          name: "analytics-orders",
        },
        {
          path: "finances",
          component: AnalyticsFinances,
          name: "analytics-finances",
        },
        {
          path: "targets",
          component: AnalyticsTargets,
          name: "analytics-targets",
        },
        {
          path: "posts",
          component: AnalyticsPosts,
          name: "analytics-posts",
        },
      ],
    },
    {
      path: "/settings",
      component: Settings,
      children: [
        { path: "",
          component: SettingsGeneral,
          name: "settings"
        },
        { path: "bank-requisites",
          component: BankRequisites,
          name: "settings-bank-requisites"
        },
        {
          path: "statuses",
          component: SettingsStatuses,
          name: "settings-statuses",
        },
        { path: "personal", component: SettingsPersonal, name: "personal" },
        { path: "widget", component: SettingsWidget, name: "widget" },
        {
          path: "import-external-data",
          component: SettingsImportExternalData,
          name: "import-external-data",
        },
        {
          path: "api-access",
          component: SettingsAPIAccess,
          name: "api-access",
        },
        {
          path: "statuses/order/:id",
          component: SettingsStatusForm,
          name: "settings-order-statuses-edit",
        },
        {
          path: "statuses/order/create",
          component: SettingsStatusForm,
          name: "settings-order-statuses-create",
        },

        {
          path: "order-stages",
          component: SettingsOrderStages,
          name: "settings-order-stages",
        },
        {
          path: "order-stages/:id",
          component: SettingsOrderStageForm,
          name: "settings-order-stages-edit",
        },
        {
          path: "order-stages/create",
          component: SettingsOrderStageForm,
          name: "settings-order-stages-create",
        },

        {
          path: "repairtime-types",
          component: SettingsRepairTimeTypes,
          name: "settings-repairtime-types",
        },
        {
          path: "repairtime-types/:id",
          component: SettingsRepairTimeTypeForm,
          name: "settings-repairtime-type-edit",
        },
        {
          path: "repairtime-types/create",
          component: SettingsRepairTimeTypeForm,
          name: "settings-repairtime-type-create",
        },
        {
          path: "repairtimetree",
          component: SettingsRepairTimeTree,
          name: "settings-repairtimetree",
        },
        {
          path: "statuses/part/:id",
          component: SettingsStatusForm,
          name: "settings-order-part-statuses-edit",
        },
        {
          path: "statuses/part/create",
          component: SettingsStatusForm,
          name: "settings-order-part-statuses-create",
        },
        {
          path: "statuses/bid/create",
          component: SettingsStatusForm,
          name: "settings-order-bid-statuses-create",
        },
        {
          path: "statuses/bid/:id",
          component: SettingsStatusForm,
          name: "settings-order-bid-statuses-edit",
        },
        {
          path: "statuses/repairtime/:id",
          component: SettingsStatusForm,
          name: "settings-order-repairtime-statuses-edit",
        },
        {
          path: "statuses/repairtime/create",
          component: SettingsStatusForm,
          name: "settings-order-repairtime-statuses-create",
        },

        {
          path: "customer-types",
          component: SettingsCustomerTypes,
          name: "settings-customer-types",
        },
        {
          path: "customer-types/:id",
          component: SettingsCustomerTypeForm,
          name: "settings-customer-types-edit",
        },
        {
          path: "customer-types/create",
          component: SettingsCustomerTypeForm,
          name: "settings-customer-types-create",
        },

        {
          path: "customer-sources",
          component: SettingsSourcesTypes,
          name: "settings-customer-sources",
        },
        {
          path: "customer-sources/:id",
          component: SettingsSourcesTypeForm,
          name: "settings-customer-sources-edit",
        },
        {
          path: "customer-sources/create",
          component: SettingsSourcesTypeForm,
          name: "settings-customer-sources-create",
        },

        {
          path: "prices-types",
          component: SettingsPricesTypes,
          name: "settings-prices-types",
        },
        {
          path: "prices-types/:id",
          component: SettingsPricesTypeForm,
          name: "settings-prices-types-edit",
        },
        {
          path: "goods-export",
          component: SettingsGoodsExport,
          name: "settings-goods-export",
        },
        {
          path: "sms-templates",
          component: SettingsSmsTemplates,
          name: "settings-sms-templates",
        },
        {
          path: "sms-templates/:id",
          component: SettingsSmsTemplateForm,
          name: "settings-sms-template-edit",
        },
        {
          path: "sms-templates/create",
          component: SettingsSmsTemplateForm,
          name: "settings-sms-template-create",
        },
        {
          path: "goods-export/ozon-seller-api",
          component: SettingsGoodsExportOzonSellerAPI,
          name: "settings-goods-export-ozon-seller-api",
        },
        {
          path: "goods-export/:id/:type",
          component: SettingsGoodsExportForm,
          name: "settings-goods-export-edit",
        },
        {
          path: "prices-types/create",
          component: SettingsPricesTypeForm,
          name: "settings-prices-types-create",
        },
        {
          path: "diagnostics",
          component: Diagnostics,
          name: "settings-diagnostics",
        },
        { path: "posts", component: SettingsPosts, name: "settings-posts" },
        {
          path: "posts/:id",
          component: SettingsPostForm,
          name: "settings-post-edit",
        },
        {
          path: "posts/create",
          component: SettingsPostForm,
          name: "settings-post-create",
        },

        {
          path: "pricemarkups",
          component: SettingsPricemarkups,
          name: "settings-pricemarkups",
        },
        {
          path: "pricemarkups/:id",
          component: SettingsPricemarkupForm,
          name: "settings-pricemarkup-edit",
        },
        {
          path: "pricemarkups/create",
          component: SettingsPricemarkupForm,
          name: "settings-pricemarkup-create",
        },

        {
          path: "telephonies",
          component: SettingsTelephonies,
          name: "settings-telephonies",
        },
        {
          path: "sms-gateways",
          component: SettingsSmsGateways,
          name: "settings-sms-gateways",
        },
        {
          path: "shop_payment_details",
          component: ShopPaymentDetails,
          name: "shop_payment_details",
        },
        {
          path: "working_hours",
          component: ShopWorkingHours,
          name: "working_hours",
        },
        {
          path: "users",
          component: Users,
          name: "users",
        },
        {
          path: "users/:id",
          name: "user",
          component: UserForm,
        },
        {
          path: "users/new",
          name: "user-create",
          component: UserForm,
        },
        {
          path: "user-roles",
          name: "user-roles",
          component: Roles,
        },
        {
          path: "am",
          name: "am-search",
          component: AMSearch,
        },
        {
          path: "am/crosses",
          name: "am-crosses",
          component: AMCrosses,
        },
        {
          path: "am/aliases",
          name: "am-aliases",
          component: AMAliases,
        },
        {
          path: "suppliers",
          name: "suppliers",
          component: Suppliers,
        },
        {
          path: "suppliers/pricelists",
          name: "pricelists",
          component: SupplierPricelists,
        },
        {
          path: "suppliers/pricelists/create",
          name: "pricelists-create",
          component: SupplierPricelistForm,
        },
        {
          path: "suppliers/pricelists/:id",
          name: "pricelist",
          component: SupplierPricelistForm,
        },

        {
          path: "shops",
          name: "settings-shops",
          component: Shops,
        },
        {
          path: "user-roles/new/",
          name: "user-role-create",
          component: RoleForm,
        },
        {
          path: "user-roles/:id",
          name: "user-role",
          component: RoleForm,
        },
        {
          path: "kkm",
          component: SettingsKKM,
          name: "settings-kkm", //настройки кассового аппарата
        },
        {
          path: "tarrifplans",
          component: SettingsTarrifplans,
          name: "settings-tarrifplans",
        },
        {
          path: "tarrifplans/:status?",
          component: SettingsTarrifplans,
          name: "settings-tarrifplans-status",
        },
        {
          path: "navigation-menu",
          component: SettingsNavigationMenu,
          name: "navigation-menu",
        },
      ],
    },
    {
      path: "/search/:search_page?/:brand?/:search_number?",
      component: Search,
      name: "search",
      beforeEnter: (to, from, next) => {
        if (
          to.path === "/search" &&
          !(
            store.getters["auth/currentShop"].tarrifplan
              .can_use_full_repairtimes ||
            store.getters["auth/currentShop"].tarrifplan
              .can_use_simple_repairtimes
          )
        ) {
          next("/search/search");
        } else {
          next();
        }
      },
    },
    { path: "/orders/:id?", component: Orders, name: "orders" },

    {
      path: "/calculations/:id?",
      component: Calculations,
      name: "calculations",
    },

    { path: "/calendar", component: Calendar, name: "calendar" },
    {
      path: "/404",
      name: "404",
      component: FatalError,
    },
    {
      path: "/i18n-error",
      name: "i18n-error",
      component: FatalError,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if(Vue.prototype.isErrorLoading18n && to.name !== "i18n-error"){
    next("/i18n-error")
    return;
  }

  if (
    to.name !== "i18n-error" &&
    to.name !== "login" &&
    to.name !== "password-recovery" &&
    to.name !== "password-reset"
  ) {
    store
      .dispatch("auth/check")
      .then(() => {
        return store.getters["auth/authenticated"] === true
          ? next()
          : next("/login");
      })
      .catch((e) => {
        console.log(e);
      });
  } else {
    next();
  }
});

export default router;
